<p>
  help works!
</p>



// WEBPACK FOOTER //
// ./src/app/platform/customer/help/help.component.html